import React from 'react';

const HowToModal = ({ onClose }) => {
    return (
        <div className="fixed inset-0 bg-black/50 z-[1200] flex items-center justify-center p-4 animate-fade-in">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg overflow-hidden relative max-h-[90vh] overflow-y-auto">
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors z-10"
                >
                    ✕
                </button>

                <div className="p-6">
                    <div className="text-center mb-6">
                        <h2 className="text-2xl font-bold text-gray-800">How It Works</h2>
                        <p className="text-gray-500 text-sm">Getting started with Clackbase</p>
                    </div>
                    <div className="space-y-6">
                        {/* 1. Find & Host */}
                        <div className="flex gap-4 items-start">
                            <div className="w-10 h-10 rounded-full bg-indigo-100 flex items-center justify-center text-xl shrink-0">
                                📍
                            </div>
                            <div>
                                <h3 className="font-bold text-gray-800">Find or Host</h3>
                                <p className="text-sm text-gray-600">
                                    Use the map to find games. <strong>Blue</strong> = Scheduled, <strong>Green</strong> = Now.
                                    Click <strong>"Host Meetup"</strong> to start your own game instantly.
                                </p>
                            </div>
                        </div>

                        {/* 2. Profiles & Karma */}
                        <div className="flex gap-4 items-start">
                            <div className="w-10 h-10 rounded-full bg-yellow-100 flex items-center justify-center text-xl shrink-0">
                                🏆
                            </div>
                            <div>
                                <h3 className="font-bold text-gray-800">Reputation Matters</h3>
                                <p className="text-sm text-gray-600">
                                    Click any player's face to see their profile. Give them a <strong>"👍 Vouch"</strong> if they're a good sport to boost their <strong>Reliability Score</strong>.
                                </p>
                            </div>
                        </div>

                        {/* 3. Clubs & Calendar */}
                        <div className="flex gap-4 items-start">
                            <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center text-xl shrink-0">
                                📅
                            </div>
                            <div>
                                <h3 className="font-bold text-gray-800">Clubs & Calendar</h3>
                                <p className="text-sm text-gray-600">
                                    Tap the <strong>Calendar</strong> icon (top right) to see upcoming Club events. Clubs have verified recurring schedules.
                                </p>
                            </div>
                        </div>

                        {/* 4. Chat */}
                        <div className="flex gap-4 items-start">
                            <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center text-xl shrink-0">
                                💬
                            </div>
                            <div>
                                <h3 className="font-bold text-gray-800">Chat & Connect</h3>
                                <p className="text-sm text-gray-600">
                                    Join a game to access its private <strong>Chat</strong>. Coordinate arrival times or trash talk (politely!) before you meet.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mt-8 text-center bg-gray-50 p-4 rounded-lg">
                    <p className="text-sm text-gray-500 mb-3">Ready to play?</p>
                    <button
                        onClick={onClose}
                        className="bg-indigo-600 text-white px-6 py-2 rounded-lg font-bold hover:bg-indigo-700 transition-colors"
                    >
                        Explore Map
                    </button>
                </div>
            </div>
        </div>
    );
};

export default HowToModal;
